import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useRef } from 'react'
import { useReveals } from '@/components/motion/reveal'
import Footer from '@/components/generals/footer'

/**
 * Page shell: content plus footer. Everything inside animates with the page
 * transition and gets the data-reveal scroll reveals wired up.
 */
export const Layout: FC<LayoutProps> = ({ children, footer = true }): ReactNode => {
    const root = useRef<HTMLDivElement>(null)

    useReveals(root)

    return (
        <div ref={root} className='relative flex min-h-screen flex-col'>
            <main id='main' className='flex-1'>
                {children}
            </main>

            {footer && <Footer />}
        </div>
    )
}
